import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Fans the caller's new phone number out onto their resources.
 *
 * Cognito owns the number itself — the dialog has already verified it there by
 * the time this runs. The user is taken from the signed request's identity, so
 * unlike the GraphQL mutation this replaces there is no user id to pass.
 */
export const postChangePhonenumber = async (phone) => {
  const apiPath = 'user/change-phonenumber';

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { phone },
    isLocalApiRequest: false,
  });

  const response = await axios(signedRequest);

  return response.data;
};
